import styled from 'styled-components'

export const PhotoBase = styled.div`
  width: 100%;
`
